<template>
  <div class="SelectedList">
    <div class="SelectedList-box">
      <div class="SelectedList-item" v-for="(item,index) in list" :key="item.title">
        <div class="item-title">
          {{ item.title }}
          <span><a :href="`/search${index===1?'?sortType=3':''}`" target="_blank" >查看更多投标方案<span class="iconfont icon-arrowright"></span></a> </span>
        </div>
        <a :href="`/detail?id=${ite.id}`" target="_blank" class="item-list" v-for="ite in item.list">
          
          <div class="title">{{ ite.title }}</div>
          <div class="time">{{ ite.updateTime }}</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import {restRecommenList,restBdList} from "@/services/home"
export default {
  name: "SelectedList",
  components: {
    
  },
  data() {
    return {
      list: [
        {
          title: "平台精选投标方案",
          list: [],
        },
        {
          title: "最新上架投标方案",
          list:[],
        },
      ],
    };
  },
  created() {
    this.getListData()
  },
  mounted() {},
  methods: {
    getListData(){
      const list = this.list
      restRecommenList().then(res => {
        this.list[0].list = res.data
      })
      restBdList({
        pageNo:1,
        pageSize:10,
      }).then(res => {
        this.list[1].list = res.data
      })

    }
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/config.scss";

.SelectedList {
  background-color: #fff;
  padding: 0px 0 32px;
  .SelectedList-box {
    width: $layout-body-width;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .SelectedList-item {
      width: 588px;
      border: 1px solid #eeeeee;
      border-radius: 6px;
      color: #282828;
      .item-title {
        height: 56px;
        padding: 16px 24px;
        display: flex;
        justify-content: space-between;
        font-weight: 550;
        font-size: 18px;
        background: #f6f6f6;
        a{
          color: #2357f5;

        }
        span {
          color: #2357f5;
          font-size: 14px;
          cursor: pointer;
          .iconfont {
            font-size: 10px;
            font-weight: 600;
            position: relative;
            top: -1px;
          }
        }
      }
      .item-list {
        display: flex;
        justify-content: space-between;
        padding: 16px 24px;
        font-size: 16px;
        color: #282828;
        cursor: pointer;
        border-bottom: 1px solid #eeeeee;
        &:last-child{
            border:0;
        }
        .title{
          flex:1;
          overflow: hidden; white-space: nowrap; text-overflow: ellipsis; 
          padding-right: 10px;
        }
        .time{
            color: #5f6272;
            font-size: 14px; 
        }
        &:hover{
            color: #2357f5;
            .time{
                color: #2357f5;

            }
        }
      }
    }
  }
}
</style>
